import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { generatePath, Link } from 'react-router-dom';

import { formatUserDateFromString, ROUTES } from '@arrived/common';
import { OfferingTransaction } from '@arrived/models';
import { useOfferingQuery } from '@arrived/queries';

import { OfferingName } from '../../OfferingName';
import { OfferingDataListItem } from './OfferingDataList';

import { PrivacyContextAwareMoneyValue } from '../common';
import { CellBodyTypography } from '../common/cells';

export interface OfferingTransactionsListItemProps {
  className?: string;
  offeringTransaction: OfferingTransaction;
}

export const OfferingTransactionsListItem = ({ className, offeringTransaction }: OfferingTransactionsListItemProps) => {
  const intl = useIntl();
  const offeringState = useOfferingQuery(offeringTransaction.offeringId, { staleTime: Infinity });

  const path = useMemo(
    () => generatePath(ROUTES.trades.tradeDetails, { tradeId: `${offeringTransaction.id}` }),
    [offeringTransaction]
  );

  return (
    <Link
      className="trade-details-link"
      to={path}
      aria-label={intl.formatMessage({ id: 'view-trade-details', defaultMessage: 'View Trade Details ' })}
    >
      <OfferingDataListItem
        className={className}
        key={offeringTransaction.id}
        left={
          <div>
            <CellBodyTypography variant="h6.semibold">
              {offeringState.data ? (
                <OfferingName name={offeringState.data.name} />
              ) : (
                <FormattedMessage id="loading" defaultMessage="Loading..." />
              )}
            </CellBodyTypography>
            {offeringTransaction.signedAt && (
              <CellBodyTypography>{formatUserDateFromString(offeringTransaction.signedAt, 'PPP')}</CellBodyTypography>
            )}
          </div>
        }
        right={
          <CellBodyTypography variant="h6.semibold">
            <PrivacyContextAwareMoneyValue length={5} value={offeringTransaction.totalAmount} />
          </CellBodyTypography>
        }
      />
    </Link>
  );
};
